import React, { useEffect, useState, useRef, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'react-bootstrap';
import workspaceBg from "../../assets/img/ws_bg.jpg";
import AgentService from '../../services/api/agents';
import UserManagementService from '../../services/api/usermanagement';
import { buildType, API_RESPONSE, hasHTMLTags, default_size, default_size_mcp, CLUSTERSTATUS } from '../../settings/shared/constants';
import SATooltip from '../common/SATooltip';  
import ProjectFilterToggle from './ProjectFilterToggle';
import { useNotification } from '../common/NotificationProvider';
import { TiFlowMerge } from "react-icons/ti";
import { checkSpecialChar } from '../../settings/shared/commonMethods';

const SHARE_ROLES = [
  { value: 'EDITOR', label: 'Editor' },
  { value: 'VIEWER', label: 'Viewer' }
];

const SHARE_USERS_PAGE_SIZE = 10;

const getShareUserKey = (user) => {
  if (!user) return '';
  if (user.id != null && user.id !== '') return String(user.id);
  if (user.email) return String(user.email).trim().toLowerCase();
  return '';
};

const resolveShareBaselineRole = (baseline, user) => {
  if (!baseline || !user) return '';
  const id = user.id != null && user.id !== '' ? String(user.id) : '';
  const email = (user.email || '').toString().trim().toLowerCase();
  if (id && baseline[id]) return baseline[id];
  if (email && baseline[email]) return baseline[email];
  return '';
};

/* ─── Inline styles shared across card ─── */
const cardStyles = `
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
  @keyframes dropdownPop {
    from { opacity: 0; transform: scale(0.88); }
    to   { opacity: 1; transform: scale(1); }
  }

  .proj-card {
    background: #f8fafc;
    border-radius: 16px;
    border: 1px solid rgba(226, 232, 240, 0.95);
    box-shadow: 0 1px 2px rgba(15, 23, 42, 0.06);
    overflow: visible;
    cursor: pointer;
    transition: transform 0.22s cubic-bezier(.34,1.56,.64,1), box-shadow 0.22s ease, border-color 0.22s ease;
    position: relative;
  }
  .proj-card:hover {
    transform: translateY(-4px);
    border-color: rgba(72, 128, 255, 0.35);
    box-shadow: 0 18px 48px rgba(2, 6, 23, 0.10), 0 10px 24px rgba(72,128,255,0.10);
  }
  .proj-card:hover .thumb-img {
    transform: scale(1.03);
  }
  .proj-card:hover .dots-btn,
  .proj-card.menu-open .dots-btn {
    opacity: 1 !important;
  }
  .card-thumb
  .proj-card:focus-visible {
    outline: 3px solid rgba(72, 128, 255, 0.35);
    outline-offset: 3px;
  }

  .card-thumb {
    position: relative;
    height: 190px;
    border-radius: 16px 16px 0 0;
    overflow: visible;
    background: #e8edf5;
  }

  .thumb-clip {
    position: relative;
    width: 100%;
    height: 100%;
    border-radius: 16px 16px 0 0;
    overflow: hidden;
    background: #e6eff9;
  }

  .thumb-clip::after {
    content: "";
    position: absolute;
    inset: 0;
    pointer-events: none;
  }

  .thumb-img {
    width: 100%;
    height: 100%;
    // object-fit: cover;
    object-position: center;
    display: block;
    transition: transform 0.4s ease;
    filter: saturate(1.02) contrast(1.02);
  }

  .thumb-frame {
    inset: 0;
    border-radius: 16px 16px 0 0;
    background: transparent;
    box-shadow: none;
    border: none;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .thumb-frame .thumb-img {
    width: 100%;
    height: 100%;
    padding: 10px;
    border-radius: 18px 18px 4px 4px;
    height: 190px
  }

  .thumb-placeholder {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 8px;
  }

.thumb-actions {
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 5;
  display: flex;
  align-items: center;
  gap: 6px;
}


  .dots-btn {
    width: 28px;
    height: 28px;
    border-radius: 8px;
    background: rgba(15, 23, 42, 0.35);
    border: 1px solid rgba(255, 255, 255, 0.35);
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    flex-shrink: 0;
    opacity: 0;
    backdrop-filter: blur(8px);
    -webkit-backdrop-filter: blur(8px);
    transition: background 0.2s ease, transform 0.2s ease, opacity 0.2s ease, border-color 0.2s ease;
  }
  .dots-btn:hover {
    background: rgba(15, 23, 42, 0.52);
    border-color: rgba(255, 255, 255, 0.55);
    transform: translateY(-1px);
  }

  .proj-dropdown {
    position: absolute;
    top: calc(100% + 8px);
    right: 0;
    background: #ffffff;
    border: 1px solid rgba(226, 232, 240, 0.95);
    border-radius: 14px;
    box-shadow: 0 18px 48px rgba(2, 6, 23, 0.18), 0 8px 18px rgba(2, 6, 23, 0.08);
    min-width: 160px;
    overflow: hidden;
    z-index: 1000;
    transform-origin: top right;
    animation: dropdownPop 0.15s cubic-bezier(.34,1.56,.64,1) forwards;
  }

  .proj-dropdown-item {
    display: flex;
    align-items: center;
    gap: 9px;
    padding: 9px 12px;
    font-size: 13px;
    font-weight: 500;
    color: #1e293b;
    cursor: pointer;
    transition: background 0.15s;
  }
  .proj-dropdown-item:hover {
    background: #f1f5ff;
  }
  .proj-dropdown-ico {
    width: 28px;
    height: 28px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    flex-shrink: 0;
  }
  .ico-blue  { background: #eff3ff; color: #4880FF; }
  .ico-green { background: #ecfdf5; color: #10b981; }

  .card-body-inner {
  padding: 12px 20px 16px 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  border-radius: 13px;
  background: #ffffff;
}

  .card-title-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.card-title-text {
  font-size: 15px;
  font-weight: 700;
  color: #0f172a;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  letter-spacing: -0.01em;
  min-width: 0;
  flex: 1;
  line-height: 1.3;
}

.status-pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 3px 10px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 700;
  flex-shrink: 0;
  white-space: nowrap;
  line-height: 1.3;
}

  .status-pill-dot {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    flex-shrink: 0;
  }

  .card-meta-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .card-meta-left {
    display: flex;
    align-items: center;
    gap: 6px;
  }

  .status-dot {
    width: 7px;
    height: 7px;
    border-radius: 50%;
    flex-shrink: 0;
  }

  .meta-time-text {
    font-size: 12px;
    color: #94a3b8;
    font-weight: 500;
  }

  .creator-avatar-circle {
    width: 28px;
    height: 28px;
    border-radius: 50%;
    background: linear-gradient(135deg, #4880FF, #2563eb);
    color: #ffffff;
    font-size: 11px;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
    letter-spacing: 0.02em;
    flex-shrink: 0;
    box-shadow: 0 8px 18px rgba(15, 23, 42, 0.12);
    border: 1px solid rgba(255,255,255,0.9);
  }

  .dots-wrapper-rel {
    position: relative;
  }

  .ws-launch-backdrop {
    position: fixed;
    inset: 0;
    z-index: 10000;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;
    background: rgba(15, 23, 42, 0.42);
    backdrop-filter: blur(6px);
    animation: wsLaunchFade 0.18s ease;
  }
  @keyframes wsLaunchFade {
    from { opacity: 0; }
    to { opacity: 1; }
  }
  .ws-launch-card {
    width: min(440px, 100%);
    background: #fff;
    border-radius: 20px;
    box-shadow: 0 28px 80px rgba(15, 23, 42, 0.22);
    padding: 22px 22px 18px;
    animation: wsLaunchPop 0.22s cubic-bezier(.34,1.56,.64,1);
  }
  @keyframes wsLaunchPop {
    from { opacity: 0; transform: translateY(10px) scale(0.96); }
    to { opacity: 1; transform: translateY(0) scale(1); }
  }
  .ws-launch-icon {
    width: 48px;
    height: 48px;
    border-radius: 14px;
    background: linear-gradient(180deg, #fff7ed 0%, #ffedd5 100%);
    color: #c2410c;
    border: 1px solid rgba(234, 88, 12, 0.14);
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    margin-bottom: 14px;
  }
  .ws-launch-card h3 {
    margin: 0 0 6px;
    font-size: 18px;
    font-weight: 750;
    color: #0f172a;
    letter-spacing: -0.02em;
  }
  .ws-launch-card p {
    margin: 0 0 16px;
    font-size: 13.5px;
    color: #64748b;
    line-height: 1.55;
  }
  .ws-launch-app {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px 14px;
    border-radius: 14px;
    background: #f8fafc;
    border: 1px solid rgba(15, 23, 42, 0.06);
    margin-bottom: 14px;
  }
  .ws-launch-app-mark {
    width: 40px;
    height: 40px;
    border-radius: 12px;
    background: linear-gradient(135deg, #4880FF, #2563eb);
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 13px;
    font-weight: 800;
    flex-shrink: 0;
  }
  .ws-launch-app-name {
    font-size: 14px;
    font-weight: 700;
    color: #0f172a;
    line-height: 1.3;
    word-break: break-word;
  }
  .ws-launch-app-meta {
    margin-top: 2px;
    font-size: 12px;
    color: #94a3b8;
  }
  .ws-launch-steps {
    display: grid;
    grid-template-columns: 1fr auto 1fr;
    align-items: center;
    gap: 8px;
    margin-bottom: 18px;
  }
  .ws-launch-step {
    padding: 10px 12px;
    border-radius: 12px;
    background: #fff;
    border: 1px solid #e2e8f0;
    text-align: center;
  }
  .ws-launch-step strong {
    display: block;
    font-size: 12px;
    font-weight: 700;
    color: #0f172a;
  }
  .ws-launch-step span {
    display: block;
    margin-top: 2px;
    font-size: 11px;
    color: #64748b;
  }
  .ws-launch-step.is-from {
    background: #fff7ed;
    border-color: rgba(234, 88, 12, 0.18);
  }
  .ws-launch-step.is-to {
    background: #eff6ff;
    border-color: rgba(72, 128, 255, 0.22);
  }
  .ws-launch-arrow {
    color: #94a3b8;
    font-size: 12px;
  }
  .ws-launch-actions {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
  }
  .ws-launch-btn {
    border: 1px solid #e2e8f0;
    background: #fff;
    color: #475569;
    border-radius: 10px;
    padding: 10px 16px;
    font-size: 13.5px;
    font-weight: 600;
    cursor: pointer;
  }
  .ws-launch-btn:hover { background: #f8fafc; }
  .ws-launch-btn.primary {
    border-color: transparent;
    background: #4880FF;
    color: #fff;
    box-shadow: 0 8px 18px rgba(72, 128, 255, 0.28);
  }
  .ws-launch-btn.primary:hover { filter: brightness(0.96); }
`;

const WorkspaceSection = () => {
  const navigate = useNavigate();
  const showNotification = useNotification();
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(0);
  const [hasMore, setHasMore] = useState(false);
  const [loadingMore, setLoadingMore] = useState(false);
  const [showScrollTop, setShowScrollTop] = useState(false);
  const [searchValue, setSearchValue] = useState('');
  const [showRenameModal, setShowRenameModal] = useState(false);
  const [renamingProject, setRenamingProject] = useState(null);
  const [renameValue, setRenameValue] = useState('');
  const [activeDropdownIndex, setActiveDropdownIndex] = useState(null);
  const [projectFilter, setProjectFilter] = useState('all');
  const [isFiltering, setIsFiltering] = useState(false);
  const [thumbnailLoadStatus, setThumbnailLoadStatus] = useState({});
  const [thumbnailObjectUrlById, setThumbnailObjectUrlById] = useState({});
  const thumbnailObjectUrlRef = useRef({});

  // Share modal state
  const [showShareModal, setShowShareModal] = useState(false);
  const [sharingProject, setSharingProject] = useState(null);
  const [tenantUsers, setTenantUsers] = useState([]);
  const [shareUserSearch, setShareUserSearch] = useState('');
  const [shareUsersPage, setShareUsersPage] = useState(0);
  const [shareSelected, setShareSelected] = useState({});
  const [shareBaseline, setShareBaseline] = useState({});
  const [shareLoading, setShareLoading] = useState(false);
  const [shareSaving, setShareSaving] = useState(false);
  const [shareRevoking, setShareRevoking] = useState(false);
  const [projectMembersList, setProjectMembersList] = useState([]);
  const projectMembersInitialAppliedRef = useRef(false);
  const [showRevokeConfirm, setShowRevokeConfirm] = useState(false);
  const [showDeletedLaunchConfirm, setShowDeletedLaunchConfirm] = useState(false);
  const [pendingLaunchProject, setPendingLaunchProject] = useState(null);
  const [pendingLaunchNewWindow, setPendingLaunchNewWindow] = useState(false);

  const hashStringToInt = (str) => {
    const s = String(str ?? '');
    let h = 2166136261;
    for (let i = 0; i < s.length; i += 1) {
      h ^= s.charCodeAt(i);
      h = Math.imul(h, 16777619);
    }
    return h >>> 0;
  };

  const getPastelBgForId = (id) => {
    const h = hashStringToInt(id);
    const hue = h % 360; // 0..359
    const sat = 78; // pastel but vivid
    const light = 92; // very light background
    return `hsl(${hue} ${sat}% ${light}%)`;
  };

  /* ─── Close dropdown on outside click ─── */
  useEffect(() => {
    const handleOutside = () => setActiveDropdownIndex(null);
    document.addEventListener('click', handleOutside);
    return () => document.removeEventListener('click', handleOutside);
  }, []);

  /* ─── Fetch projects ─── */
  const fetchProjects = async ({
    page = 0,
    append = false,
    search = '',
    filter = projectFilter
  } = {}) => {
    if (append && (loadingMore || !hasMore)) return;
    if (append) {
      setLoadingMore(true);
    } else {
      setLoading(true);
      setError(null);
    }
    try {
      let payload = {};

      if (filter === "mine" && currentUserId) {
        payload.userId = currentUserId;
      }

      if (search) {
        payload.name = search;
      }
  
      const savedFilter = localStorage.getItem('workspaceProjectFilter')  || 'all';
      let size = savedFilter === 'mine' ? 20 : default_size;
      const response = await AgentService.getProject(page, payload, size);
      const data = response?.projectDTOS;
      const projectsData = data?.content ?? [];
      const totalPages = data?.totalPages ?? 0;
      const isLast = data?.last ?? true;
      setProjects(prev => (append ? [...prev, ...projectsData] : projectsData));
      setCurrentPage(page);
      setHasMore(!isLast && page < totalPages - 1);
    } catch (err) {
      console.error('Error fetching projects:', err);
      setError('Failed to load projects. Please try again.');
    } finally {
      append ? setLoadingMore(false) : setLoading(false);
    }
  };

  useEffect(() => {
    const savedFilter =
      localStorage.getItem('workspaceProjectFilter') || 'all';

    if (savedFilter === 'all' || savedFilter === 'mine') {
      setProjectFilter(savedFilter);
    }

    fetchProjects({
      filter: savedFilter
    });
  }, []);

  // Convert base64 thumbnails into blob URLs asynchronously for faster UI rendering.
  useEffect(() => {
    if (!Array.isArray(projects) || projects.length === 0) return;

    const schedule =
      window.requestIdleCallback
        ? (fn) => window.requestIdleCallback(fn, { timeout: 800 })
        : (fn) => window.setTimeout(fn, 0);

    const cancel =
      window.cancelIdleCallback
        ? (id) => window.cancelIdleCallback(id)
        : (id) => window.clearTimeout(id);

    const makeDataUrl = (base64) => {
      if (!base64 || typeof base64 !== 'string') return null;
      const v = base64.trim();
      if (!v) return null;
      if (v.startsWith('data:image/')) return v;
      return `data:image/png;base64,${v}`;
    };

    const jobs = [];
    projects.forEach((p) => {
      const cardId = p?.id || p?._id;
      if (!cardId) return;

      // Prefer URL thumbnails; don't waste work converting base64 in that case.
      const hasUrlThumb = !!(p?.thumbnailUrl || p?.thumbnailURL || p?.thumbnail || p?.imageUrl);
      if (hasUrlThumb) return;

      if (thumbnailObjectUrlRef.current[cardId]) return;

      const dataUrl = makeDataUrl(p?.thumbnailBase64 || p?.thumbnail_base64);
      if (!dataUrl) return;

      const jobId = schedule(async () => {
        try {
          const res = await fetch(dataUrl);
          const blob = await res.blob();
          const objectUrl = URL.createObjectURL(blob);
          thumbnailObjectUrlRef.current[cardId] = objectUrl;
          setThumbnailObjectUrlById((prev) => ({ ...prev, [cardId]: objectUrl }));
        } catch (e) {
          // If conversion fails, we simply fall back to placeholder / direct data URL rendering.
          // Avoid noisy logs in the workspace grid.
        }
      });
      jobs.push(jobId);
    });

    return () => {
      jobs.forEach(cancel);
    };
  }, [projects]);

  useEffect(() => {
    return () => {
      Object.values(thumbnailObjectUrlRef.current).forEach((url) => {
        try {
          URL.revokeObjectURL(url);
        } catch {
          // ignore
        }
      });
      thumbnailObjectUrlRef.current = {};
    };
  }, []);

  const loadMoreProjects = () => {
    if (!loadingMore && hasMore)
      fetchProjects({ page: currentPage + 1, append: true, search: searchValue });
  };

  const handleRefreshWorkspace = () => {
    const s = searchValue.trim();
    fetchProjects({ page: 0, append: false, search: s.length >= 2 ? s : '' });
  };

  /* ─── Scroll detection ─── */
  useEffect(() => {
    const handleScroll = () => {
      setShowScrollTop((window.scrollY || document.documentElement.scrollTop) > 300);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    const el = document.getElementById('workspace-section');
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  /* ─── Search ─── */
  const handleSearchProjects = (event) => {
    const val = event.target.value;
    setSearchValue(val);
    if (val.length >= 2) fetchProjects({ page: 0, append: false, search: val });
    else if (val.length === 0) fetchProjects({ page: 0, append: false, search: '' });
  };

  /* ─── Rename ─── */
  const handleEditName = (e, project) => {
    e.stopPropagation();
    setRenamingProject(project);
    setRenameValue(project?.name || 'Untitled Project');
    setShowRenameModal(true);
    setActiveDropdownIndex(null);
  };

  const handleSaveRename = async () => {
    if (!renameValue.trim()) {
      showNotification('Project name cannot be empty', 'error', 'topCenter');
      return;
    }
    if (hasHTMLTags(renameValue)) {
      showNotification('HTML tags are not allowed in the project name', 'error', 'topCenter');
      return;
    }
    if (!checkSpecialChar(renameValue)) {
      showNotification('Special characters are not allowed in the project name', 'error', 'topCenter');
      return;
    }
    if (!renamingProject) return;
    try {
      const projectId = renamingProject.id || renamingProject._id;
      const response = await AgentService.updateProject(projectId, { name: renameValue.trim() });
      if (response?.status === API_RESPONSE.SUCCESS) {
        showNotification('Project name updated successfully', 'success', 'topCenter');
        setShowRenameModal(false);
        setRenamingProject(null);
        setRenameValue('');
        setProjects(prev =>
          prev.map(p => p.id === projectId ? { ...p, name: renameValue.trim() } : p)
        );
      } else {
        showNotification(response?.errorMessage || 'Failed to update project name', 'error', 'topCenter');
      }
    } catch (err) {
      console.error('Error updating project name:', err);
      showNotification('Failed to update project name', 'error', 'topCenter');
    }
  };

  const handleCloseRenameModal = () => {
    setShowRenameModal(false);
    setRenamingProject(null);
    setRenameValue('');
  };

  /* ─── Filter ─── */
  const currentUserId = useMemo(() => localStorage.getItem('Uid'), []);

  const filteredProjects = useMemo(() => {
    if (!Array.isArray(projects)) return [];
    if (projectFilter !== 'mine') return projects;
    if (!currentUserId) return [];
    return projects.filter(p => {
      const ownerId = p?.userId || p?.createdById || p?.ownerId;
      return ownerId && String(ownerId) === String(currentUserId);
    });
  }, [projects, projectFilter, currentUserId]);

  const handleProjectFilterChange = (nextFilter) => {
    if (nextFilter !== 'all' && nextFilter !== 'mine') return;

    setProjectFilter(nextFilter);
    localStorage.setItem('workspaceProjectFilter', nextFilter);

    setIsFiltering(true);

    fetchProjects({
      page: 0,
      append: false,
      filter: nextFilter,
      search: searchValue
    });

    setTimeout(() => setIsFiltering(false), 180);
  };

  const isDeletedProject = (project) =>
    String(project?.projectStatus || '').toUpperCase() === CLUSTERSTATUS.DELETED;

  const getProjectPath = (project) => {
    if (project?.buildType === buildType.AGENT_EXECUTION) {
      return `/app/agent?projectId=${project.id}`;
    }
    const appType = String(project?.appType ?? '').toUpperCase();
    if (appType === 'XRAY') {
      return `/project/${project.id}?section=frontend`;
    }
    return `/project/${project.id}`;
  };

  const navigateToProject = (project, { newWindow = false } = {}) => {
    if (!project?.id) return;
    const path = getProjectPath(project);
    if (newWindow) {
      window.open(`${window.location.origin}${path}`, '_blank', 'noopener,noreferrer');
      return;
    }
    navigate(path);
  };

  const requestOpenProject = (project, { newWindow = false } = {}) => {
    if (project?.appType === 'AGENT') return;
    const deleted = isDeletedProject(project);
  
    if (deleted) {
      setPendingLaunchProject(project);
      setPendingLaunchNewWindow(newWindow);
      setShowDeletedLaunchConfirm(true);
      return;
    }
  
    navigateToProject(project, { newWindow });
  };

  const handleCloseDeletedLaunchConfirm = () => {
    setShowDeletedLaunchConfirm(false);
    setPendingLaunchProject(null);
    setPendingLaunchNewWindow(false);
  };

  const handleConfirmDeletedLaunch = () => {
    const project = pendingLaunchProject;
    const newWindow = pendingLaunchNewWindow;
    handleCloseDeletedLaunchConfirm();
    if (project) navigateToProject(project, { newWindow });
  };

  useEffect(() => {
    if (!showDeletedLaunchConfirm) return undefined;
    const onKeyDown = (e) => {
      if (e.key === 'Escape') handleCloseDeletedLaunchConfirm();
    };
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [showDeletedLaunchConfirm]);

  /* ─── Open in new window ─── */
  const handleOpenInNewWindow = (e, project) => {
    e.stopPropagation();
    setActiveDropdownIndex(null);
    requestOpenProject(project, { newWindow: true });
  };

  /* ─── Share modal ─── */
  const handleOpenShare = (e, project) => {
    e.stopPropagation();
    setSharingProject(project);
    setShowShareModal(true);
    setShareUserSearch('');
    setShareUsersPage(0);
    setShareSelected({});
    setProjectMembersList([]);
    projectMembersInitialAppliedRef.current = false;
    setActiveDropdownIndex(null);
  };

  const handleCloseShareModal = () => {
    setShowShareModal(false);
    setSharingProject(null);
    setTenantUsers([]);
    setShareUserSearch('');
    setShareUsersPage(0);
    setShareSelected({});
    setShareBaseline({});
    setProjectMembersList([]);
    projectMembersInitialAppliedRef.current = false;
    setShowRevokeConfirm(false);
    setShareRevoking(false);
  };

  useEffect(() => {
    if (!showShareModal || !sharingProject) return;
    const accountId = localStorage.getItem('accountId');
    if (!accountId) {
      showNotification('Account information is missing. Please login again.', 'error', 'topCenter');
      return;
    }
    const projectId = sharingProject?.id || sharingProject?._id;
    setShareLoading(true);

    const loadTenantUsers = UserManagementService.getuserlist(accountId,0, default_size_mcp)
      .then(response => {
        if (response?.status === API_RESPONSE.SUCCESS && response.userDTOS) {
          const currentUId = localStorage.getItem('Uid');
          const listWithoutSelf = currentUId
            ? response.userDTOS.filter(u => (u?.id || u?.email) !== currentUId)
            : response.userDTOS;
          setTenantUsers(listWithoutSelf);
        } else {
          showNotification(response?.errorMessage || 'Failed to load users', 'error', 'topCenter');
          setTenantUsers([]);
        }
      })
      .catch(err => {
        console.error('Error fetching tenant users:', err);
        showNotification('Failed to load users', 'error', 'topCenter');
        setTenantUsers([]);
      });

    const loadProjectMembers = projectId
      ? AgentService.projectMembers(projectId)
          .then(res => {
            const list = res?.projectMemberDTOPage?.content ?? (Array.isArray(res?.content) ? res.content : res);
            setProjectMembersList(Array.isArray(list) ? list : []);
          })
          .catch(err => { console.error('Error fetching project members:', err); setProjectMembersList([]); })
      : Promise.resolve();

    Promise.all([loadTenantUsers, loadProjectMembers]).finally(() => setShareLoading(false));
  }, [showShareModal, sharingProject]);

  useEffect(() => {
    if (!showShareModal || !sharingProject) return;
    if (projectMembersList.length === 0 && tenantUsers.length === 0) return;
    if (projectMembersInitialAppliedRef.current && tenantUsers.length > 0) return;

    const initialBaseline = {};
    const initialSelected = {};
    projectMembersList.forEach((m) => {
      const memberId = m?.userId ?? m?.id ?? m?.user?.id ?? m?.user?.userId;
      const memberEmail = ((m?.email ?? m?.user?.email) || '').toString().trim().toLowerCase();
      let role = ((m?.role ?? m?.projectRole) || '').toString().toUpperCase();
      if (role && role !== 'EDITOR' && role !== 'VIEWER') role = 'EDITOR';
      if (!role) return;

      const tenantUser = tenantUsers.find((u) =>
        (memberId && (String(u?.id) === String(memberId) || String((u?.email) || '').toLowerCase() === String(memberId).toLowerCase())) ||
        (memberEmail && String((u?.email) || '').toLowerCase() === memberEmail)
      );

      const primaryKey = tenantUser
        ? getShareUserKey(tenantUser)
        : (memberId != null && memberId !== '' ? String(memberId) : memberEmail);
      if (!primaryKey) return;

      initialBaseline[primaryKey] = role;
      initialSelected[primaryKey] = role;

      // Keep email alias in baseline only (for status lookups), not in selection counts.
      if (tenantUser?.email) {
        const emailKey = String(tenantUser.email).trim().toLowerCase();
        if (emailKey && emailKey !== primaryKey) initialBaseline[emailKey] = role;
      } else if (memberEmail && memberEmail !== primaryKey) {
        initialBaseline[memberEmail] = role;
      }
    });

    // Pre-check already shared users so they can be revoked / updated immediately.
    setShareSelected(initialSelected);
    setShareBaseline(initialBaseline);
    if (tenantUsers.length > 0 || projectMembersList.length === 0) {
      projectMembersInitialAppliedRef.current = true;
    }
  }, [showShareModal, sharingProject, tenantUsers, projectMembersList]);

  const shareDisplayUsers = React.useMemo(() => {
    const tenantKeys = new Set(tenantUsers.map((u) => getShareUserKey(u)).filter(Boolean));
    const extra = Object.keys(shareBaseline).filter((uid) => {
      if (tenantKeys.has(uid)) return false;
      // Skip email aliases when the same member is already represented by id.
      if (uid.includes('@')) {
        return !tenantUsers.some((u) => String((u?.email) || '').toLowerCase() === uid);
      }
      return true;
    });
    const placeholders = extra.map((uid) => ({
      id: uid.includes('@') ? undefined : uid,
      email: uid.includes('@') ? uid : '',
      firstName: 'Shared user',
      lastName: '',
    }));
    return [...tenantUsers, ...placeholders];
  }, [tenantUsers, shareBaseline]);

  const filteredShareUsers = React.useMemo(() => {
    if (!shareUserSearch.trim()) return shareDisplayUsers;
    const q = shareUserSearch.trim().toLowerCase();
    return shareDisplayUsers.filter((u) => {
      const name = `${u.firstName || ''} ${u.lastName || ''}`.trim().toLowerCase();
      const email = (u.email || '').toLowerCase();
      return name.includes(q) || email.includes(q);
    });
  }, [shareDisplayUsers, shareUserSearch]);

  const shareUsersTotalPages = Math.max(1, Math.ceil(filteredShareUsers.length / SHARE_USERS_PAGE_SIZE));
  const paginatedShareUsers = React.useMemo(() => {
    const start = shareUsersPage * SHARE_USERS_PAGE_SIZE;
    return filteredShareUsers.slice(start, start + SHARE_USERS_PAGE_SIZE);
  }, [filteredShareUsers, shareUsersPage]);

  const selectedShareIds = React.useMemo(
    () => Object.keys(shareSelected).filter((id) => !!shareSelected[id]),
    [shareSelected],
  );

  const selectedShareCount = selectedShareIds.length;

  const isSelectedUserShared = React.useCallback((userId) => {
    const selectedUser = shareDisplayUsers.find((u) => getShareUserKey(u) === String(userId));
    if (selectedUser) return !!resolveShareBaselineRole(shareBaseline, selectedUser);
    return !!shareBaseline[userId];
  }, [shareDisplayUsers, shareBaseline]);

  const selectedRevokeIds = React.useMemo(
    () => selectedShareIds.filter((userId) => isSelectedUserShared(userId)),
    [selectedShareIds, isSelectedUserShared],
  );

  const selectedRevokeCount = selectedRevokeIds.length;

  // Share access should count only newly selected (not already shared) users.
  const selectedNewShareIds = React.useMemo(
    () => selectedShareIds.filter((userId) => !isSelectedUserShared(userId)),
    [selectedShareIds, isSelectedUserShared],
  );

  const selectedNewShareCount = selectedNewShareIds.length;

  const pageUserIds = React.useMemo(
    () => paginatedShareUsers.map((u) => getShareUserKey(u)).filter(Boolean),
    [paginatedShareUsers],
  );

  const allPageSelected = pageUserIds.length > 0 && pageUserIds.every((id) => !!shareSelected[id]);
  const somePageSelected = pageUserIds.some((id) => !!shareSelected[id]);

  const handleShareToggleUser = (userId, checked, user) => {
    const key = String(userId || '');
    if (!key) return;
    setShareSelected((prev) => {
      const next = { ...prev };
      if (checked) {
        next[key] = prev[key]
          || resolveShareBaselineRole(shareBaseline, user)
          || shareBaseline[key]
          || SHARE_ROLES[0].value;
      } else {
        delete next[key];
      }
      return next;
    });
    setShowRevokeConfirm(false);
  };

  const handleShareTogglePage = () => {
    // Explicit toggle avoids indeterminate checkbox browser quirks
    // where only "checked=true" clicks appeared to work.
    const shouldSelectAll = !allPageSelected;
    setShareSelected((prev) => {
      const next = { ...prev };
      paginatedShareUsers.forEach((user) => {
        const userId = getShareUserKey(user);
        if (!userId) return;
        if (shouldSelectAll) {
          next[userId] = next[userId]
            || resolveShareBaselineRole(shareBaseline, user)
            || shareBaseline[userId]
            || SHARE_ROLES[0].value;
        } else {
          delete next[userId];
        }
      });
      return next;
    });
    setShowRevokeConfirm(false);
  };

  const handleShareRoleChange = (userId, role) => {
    const key = String(userId || '');
    if (!key || !role) return;
    // Role changes only apply to already checkbox-selected users.
    setShareSelected((prev) => {
      if (!prev[key]) return prev;
      return { ...prev, [key]: role };
    });
  };

  const handleSaveShare = async () => {
    const projectId = sharingProject?.id || sharingProject?._id;
    if (!projectId) return;
    const entries = selectedNewShareIds
      .map((userId) => [userId, shareSelected[userId]])
      .filter(([, role]) => !!role);
    if (entries.length === 0) {
      showNotification('Select at least one user who is not already shared', 'error', 'topCenter');
      return;
    }
    setShareSaving(true);
    try {
      const payload = {
        members: entries.map(([userId, role]) => ({ userId, role })),
        projectId,
        accountId: localStorage.getItem('accountId'),
      };
      await AgentService.shareProject(payload);
      showNotification(
        entries.length === 1
          ? 'Access shared successfully'
          : `Access shared with ${entries.length} users`,
        'success',
        'topCenter',
      );
      handleCloseShareModal();
    } catch (err) {
      console.error('Error sharing project:', err);
      showNotification(err?.response?.data?.errorMessage || 'Failed to share access', 'error', 'topCenter');
    } finally {
      setShareSaving(false);
    }
  };

  const handleRevokeSelected = async () => {
    const projectId = sharingProject?.id || sharingProject?._id;
    if (!projectId || selectedRevokeIds.length === 0) return;
    setShareRevoking(true);
    setShowRevokeConfirm(false);
    try {
      const results = await Promise.allSettled(
        selectedRevokeIds.map((userId) => AgentService.revokeProjectMember(projectId, userId)),
      );
      const revokedIds = [];
      results.forEach((result, index) => {
        const userId = selectedRevokeIds[index];
        if (result.status === 'fulfilled' && result.value?.status === API_RESPONSE.SUCCESS) {
          revokedIds.push(userId);
        }
      });

      if (revokedIds.length > 0) {
        setShareSelected((prev) => {
          const next = { ...prev };
          revokedIds.forEach((id) => delete next[id]);
          return next;
        });
        setShareBaseline((prev) => {
          const next = { ...prev };
          revokedIds.forEach((id) => {
            delete next[id];
            const user = shareDisplayUsers.find((u) => getShareUserKey(u) === String(id));
            const email = (user?.email || '').toString().trim().toLowerCase();
            if (email) delete next[email];
          });
          return next;
        });
        setProjectMembersList((prev) =>
          prev.filter((m) => {
            const memberId = m?.userId ?? m?.id ?? m?.user?.id ?? m?.user?.userId;
            const memberEmail = ((m?.email ?? m?.user?.email) || '').toString().trim().toLowerCase();
            return !revokedIds.some(
              (id) =>
                String(id) === String(memberId) ||
                String(id).toLowerCase() === memberEmail ||
                String(id) === String(memberEmail),
            );
          }),
        );
      }

      if (revokedIds.length === selectedRevokeIds.length) {
        showNotification(
          revokedIds.length === 1
            ? 'Access revoked successfully'
            : `Access revoked for ${revokedIds.length} users`,
          'success',
          'topCenter',
        );
      } else if (revokedIds.length > 0) {
        showNotification(
          `Revoked ${revokedIds.length} of ${selectedRevokeIds.length} users. Some failed.`,
          'error',
          'topCenter',
        );
      } else {
        showNotification('Failed to revoke access', 'error', 'topCenter');
      }
    } catch (err) {
      console.error('Error revoking access:', err);
      showNotification('Failed to revoke access', 'error', 'topCenter');
    } finally {
      setShareRevoking(false);
    }
  };

  /* ─── Helpers ─── */
  const formatDate = (dateString) => {
    if (!dateString) return 'Recently';
    const date = new Date(dateString);
    const diff = Math.floor((Date.now() - date) / 1000);
    if (diff < 60) return `${diff}s ago`;
    if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
    if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
    const days = Math.floor(diff / 86400);
    if (days === 1) return '1 day ago';
    if (days < 7) return `${days} days ago`;
    if (days < 30) return `${Math.ceil(days / 7)}w ago`;
    return date.toLocaleDateString();
  };

  const getInitials = (name) => {
    if (!name) return 'U';
    return name.split(' ').map(w => w[0]).join('').toUpperCase().slice(0, 2);
  };

  
const RUNNING_STATUS_KEYS = new Set(['success', 'completed', 'restored', 'streaming', 'running']);
const DELETED_STATUS_KEY = 'deleted';

const getStatusColor = (status) => {
  const key = (status || '').toLowerCase();
  if (key === DELETED_STATUS_KEY) return '#f59e0b';
  return RUNNING_STATUS_KEYS.has(key) ? '#22c55e' : '#94a3b8';
};

const getStatusLabel = (status) => {
  const key = (status || '').toLowerCase();
  if (key === 'success' || key === 'completed' || key === 'streaming' || key === 'restored' || key === 'running') return 'Running';
  return 'Stopped';
};

const getStatusPillStyle = (status) => {
  const key = (status || '').toLowerCase();
  return RUNNING_STATUS_KEYS.has(key)
    ? { bg: 'rgba(34,197,94,0.14)', color: '#15803d' }
    : { bg: 'rgba(148,163,184,0.14)', color: '#64748b' };
};


  /* ─── Empty / Loading / Error states ─── */
  const renderEmptyState = () => (
    <div style={{
      display: 'flex', flexDirection: 'column', alignItems: 'center',
      justifyContent: 'center', minHeight: '400px', textAlign: 'center', padding: '2rem'
    }}>
      <div style={{
        width: '120px', height: '120px', backgroundColor: '#f1f5f9', borderRadius: '50%',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        marginBottom: '1.5rem', border: '3px dashed #cbd5e1'
      }}>
        <i className="fa-solid fa-folder-plus" style={{ fontSize: '48px', color: '#94a3b8' }}></i>
      </div>
      <h3 style={{ fontSize: '1.5rem', fontWeight: '600', color: '#1e293b', marginBottom: '0.5rem' }}>
        No Projects Yet
      </h3>
      <p style={{ fontSize: '1rem', color: '#64748b', marginBottom: '2rem', maxWidth: '400px', lineHeight: '1.5' }}>
        Create, deploy, and manage your first AI agent via chat.
      </p>
    </div>
  );

  const renderLoadingState = () => (
    <div style={{
      display: 'flex', flexDirection: 'column', alignItems: 'center',
      justifyContent: 'center', minHeight: '400px', textAlign: 'center', padding: '2rem'
    }}>
      <div style={{
        width: '48px', height: '48px', border: '4px solid #e2e8f0',
        borderTop: '4px solid #4880FF', borderRadius: '50%',
        animation: 'spin 1s linear infinite', marginBottom: '1rem'
      }}></div>
      <p style={{ fontSize: '1rem', color: '#64748b' }}>Loading your projects...</p>
    </div>
  );

  const renderErrorState = () => (
    <div style={{
      display: 'flex', flexDirection: 'column', alignItems: 'center',
      justifyContent: 'center', minHeight: '400px', textAlign: 'center', padding: '2rem'
    }}>
      <div style={{
        width: '80px', height: '80px', backgroundColor: '#fef2f2', borderRadius: '50%',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        marginBottom: '1.5rem', border: '2px solid #fecaca'
      }}>
        <i className="fa-solid fa-exclamation-triangle" style={{ fontSize: '32px', color: '#ef4444' }}></i>
      </div>
      <h3 style={{ fontSize: '1.25rem', fontWeight: '600', color: '#dc2626', marginBottom: '0.5rem' }}>
        Something went wrong
      </h3>
      <p style={{ fontSize: '1rem', color: '#64748b', marginBottom: '1.5rem' }}>{error}</p>
      <button
        className="btn btn-outline-primary"
        style={{
          backgroundColor: 'transparent', border: '1px solid #4880FF',
          padding: '10px 20px', borderRadius: '6px', color: '#4880FF',
          fontSize: '14px', fontWeight: '500', cursor: 'pointer'
        }}
        onClick={() => window.location.reload()}
      >
        <i className="fa-solid fa-refresh me-2"></i>Try Again
      </button>
    </div>
  );

  /* ─── Project Card ─── */
  const renderCard = (project) => {
    const cardId = project.id || project._id;
    const appName = project?.name || 'Untitled App';
    const appTypeRaw = project?.appType ?? null;
    const appType = (appTypeRaw ? String(appTypeRaw).toUpperCase() : 'AGENT_EXECUTION'); // null => AGENT_EXECUTION
    const isAppLike = appType === 'APP' || appType === 'APP_AGENT';
    const isWebsite = appType === 'WEBSITE';
    const isXray = appType === 'XRAY';
    const isWorkflow = !isAppLike && !isWebsite && !isXray; // AGENT_EXECUTION / AGENT / unknown
    const workflowIconName = appType === 'AGENT' ? 'fa-robot' : 'fa-diagram-project';
    const thumbnailUrl =
      project?.thumbnailUrl ||
      project?.thumbnailURL ||
      project?.thumbnailBaseUrl ||
      project?.thumbnailBaseURL ||
      project?.thumbnail ||
      project?.imageUrl ||
      null;
    const thumbnailBase64 = project?.thumbnailBase64 || project?.thumbnail_base64 || null;
    const thumbnailBase64Src = (() => {
      if (!thumbnailBase64 || typeof thumbnailBase64 !== 'string') return null;
      const v = thumbnailBase64.trim();
      if (!v) return null;
      if (v.startsWith('data:image/')) return v;
      // If API returns raw base64 without data URL prefix.
      return `data:image/png;base64,${v}`;
    })();
    const thumbnailObjectUrl = thumbnailObjectUrlById[cardId] || null;
    const thumbnailSrc = thumbnailUrl || thumbnailObjectUrl || thumbnailBase64Src || null;
    const isMenuOpen = activeDropdownIndex === cardId;
    const isOwner = project?.userId === localStorage.getItem('Uid');
    const creatorLabel = (project?.createdBy || project?.createdByName || project?.ownerName || '').toString().trim();
    const creatorInitials = getInitials(creatorLabel || 'U');
    const avatarBg = 'linear-gradient(135deg, #4880FF, #2563eb)';

    return (
      <div
        key={cardId}
        className={`proj-card${isMenuOpen ? ' menu-open' : ''}`}
        onClick={() => requestOpenProject(project)}
      >
        {/* ── Thumbnail ── */}
        <div className="card-thumb">
          <div
            className="thumb-clip"
            style={{
              '--thumbBg': getPastelBgForId(cardId || appName),
            }}
          >
            {thumbnailSrc && thumbnailLoadStatus[cardId] !== false ? (
              <div className="thumb-frame">
                <img
                  className="thumb-img"
                  src={thumbnailSrc}
                  alt={appName}
                  loading="lazy"
                  decoding="async"
                  onLoad={() => setThumbnailLoadStatus(prev => ({ ...prev, [cardId]: true }))}
                  onError={() => setThumbnailLoadStatus(prev => ({ ...prev, [cardId]: false }))}
                />
              </div>
            ) : isXray ? (
              <div className="thumb-placeholder">
                <span style={{ position: 'relative', width: 52, height: 44, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', opacity: 0.6 }}>
                  <i className="fa-solid fa-laptop-code" style={{ fontSize: '38px', color: '#bdc7d5', opacity: 0.95 }}></i>
                  <i className="fa-solid fa-wand-magic-sparkles" style={{ position: 'absolute', top: -2, right: -2, fontSize: '15px', color: '#94a3b8' }}></i>
                </span>
                <span style={{ fontSize: '11px', color: '#94a3b8', textTransform: 'uppercase', letterSpacing: '0.06em', fontWeight: 700, opacity: 0.9 }}>
                  Modernize
                </span>
              </div>
            ) : isWorkflow ? (
              <div className="thumb-placeholder">
                {/* <i className={`fa-solid ${workflowIconName}`} style={{ fontSize: '50px', color: '#bdc7d5', opacity: 0.95 }}></i> */}
                <TiFlowMerge className={`fa-solid ${workflowIconName}`} style={{ fontSize: '50px', color: '#bdc7d5', opacity: 0.5 }}/>
              </div>
            ) : isWebsite ? (
              <div
                className="thumb-placeholder"
                style={{ background: 'linear-gradient(145deg, rgba(72,128,255,0.18) 0%, rgba(15,23,42,0.06) 100%)' }}
              >
                <i className="fa-solid fa-globe" style={{ fontSize: '40px', color: '#4880FF', opacity: 0.95 }}></i>
                <span style={{ fontSize: '11px', color: '#1e293b', textTransform: 'uppercase', letterSpacing: '0.06em', fontWeight: 700, opacity: 0.75 }}>
                  Website
                </span>
              </div>
            ) : (
              <div className="thumb-placeholder">
                <i className="fa-solid fa-image" style={{ fontSize: '36px', color: '#94a3b8', opacity: 0.3 }}></i>
                <span style={{ fontSize: '11px', color: '#94a3b8', textTransform: 'uppercase', letterSpacing: '0.05em', fontWeight: 500 }}>
                  No preview
                </span>
              </div>
            )}
          </div>

          {/* ── 3-dot menu (top-right) ── */}
          <div className="thumb-actions" onClick={e => e.stopPropagation()}>
            <div className="dots-wrapper-rel">
              <button
                className="dots-btn"
                title="Options"
                onClick={(e) => {
                  e.stopPropagation();
                  setActiveDropdownIndex(isMenuOpen ? null : cardId);
                }}
              >
                <i className="fa-solid fa-ellipsis-vertical" style={{ fontSize: '13px', color: '#ffffff' }}></i>
              </button>

              {isMenuOpen && (
                <div className="proj-dropdown">
                  <div className="proj-dropdown-item" onClick={(e) => handleEditName(e, project)}>
                    <span className="proj-dropdown-ico ico-blue">
                      <i className="fa-solid fa-pencil" style={{ fontSize: '11px' }}></i>
                    </span>
                    Rename
                  </div>
                  <div className="proj-dropdown-item" onClick={(e) => handleOpenInNewWindow(e, project)}>
                    <span className="proj-dropdown-ico ico-blue">
                      <i className="fa-solid fa-up-right-from-square" style={{ fontSize: '11px' }}></i>
                    </span>
                    New window
                  </div>
                  {isOwner && (
                    <div className="proj-dropdown-item" onClick={(e) => handleOpenShare(e, project)}>
                      <span className="proj-dropdown-ico ico-green">
                        <i className="fa-solid fa-share-nodes" style={{ fontSize: '11px' }}></i>
                      </span>
                      Share
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>

        {/* ── Card body ── */}
        <div className="card-body-inner">
          <div className="card-title-row">
            <div className="card-title-text" title={appName}>{appName}</div>
              <span
                className="status-pill"
                style={{
                  background: getStatusPillStyle(project.projectStatus).bg,
                  color: getStatusPillStyle(project.projectStatus).color,
                }}
              >
                <span className="status-pill-dot" style={{ background: getStatusColor(project.projectStatus) }}></span>
                {getStatusLabel(project.projectStatus)}
              </span>
          </div>
          <div className="card-meta-row">
            <div className="card-meta-left">
              <div
                className="status-dot"
                style={{ background: project.status === 'active' ? '#22c55e' : '#f59e0b' }}
              ></div>
              <span className="meta-time-text">Edited {formatDate(project.updatedDate)}</span>
            </div>
            <div
              className="creator-avatar-circle"
              title={creatorLabel || undefined}
              style={{ background: avatarBg }}
            >
              {creatorInitials}
            </div>
          </div>
        </div>
      </div>
    );
  };

  /* ─── Render ─── */
  return (
    <div
      className="workspace-section"
      id="workspace-section"
      style={{
        backgroundImage: `url(${workspaceBg})`,
        backgroundRepeat: 'round',
        padding: '2rem',
        minHeight: '100vh'
      }}
    >
      <style>{cardStyles}</style>

      <div>
        {/* ── Header ── */}
        <div className="workspace-header d-flex mb-4 gap-4 align-items-center justify-content-between flex-wrap">
          <div className="d-flex align-items-center gap-2 mb-2 mb-md-0">
            <h2 className="workspace-title mb-0" style={{ fontSize: '2rem', fontWeight: '700', color: '#1e293b' }}>
              My Workspace
            </h2>
            <button
              className="btn d-flex align-items-center justify-content-center"
              onClick={handleRefreshWorkspace}
              disabled={loading}
              title={loading ? 'Refreshing...' : 'Refresh Workspace'}
              style={{
                backgroundColor: 'transparent', border: '1px solid #e2e8f0',
                padding: '8px', borderRadius: '8px', color: '#64748b', fontSize: '16px',
                cursor: loading ? 'not-allowed' : 'pointer', opacity: loading ? 0.6 : 1,
                width: '32px', height: '32px', transition: 'all 0.3s ease'
              }}
            >
              <i
                className={`fa-solid ${loading ? 'fa-spinner' : 'fa-refresh'}`}
                style={{ animation: loading ? 'spin 1s linear infinite' : 'none', fontSize: '14px' }}
              ></i>
            </button>
            <input
              type="text"
              placeholder="Search Projects"
              value={searchValue}
              onChange={handleSearchProjects}
              className="form-control"
              style={{
                width: '260px', height: '40px', borderRadius: '8px',
                border: '1px solid #e2e8f0', padding: '8px 12px', fontSize: '14px', fontWeight: '500'
              }}
            />
          </div>
            <div className="d-flex align-items-center gap-3 flex-wrap">
              <ProjectFilterToggle value={projectFilter} onChange={handleProjectFilterChange} />
            </div>
        </div>

        {searchValue.trim().length >= 2 && (
          <div
            className="mb-3 d-flex align-items-center gap-2 flex-wrap"
            role="status"
            style={{
              padding: '10px 14px',
              borderRadius: '10px',
              backgroundColor: '#eff6ff',
              border: '1px solid #bfdbfe',
              color: '#1e40af',
              fontSize: '14px',
              fontWeight: '500',
            }}
          >
            <i className="fa-solid fa-magnifying-glass" style={{ fontSize: '13px', opacity: 0.85 }} aria-hidden />
            <span>
              Project list is filtered by name:{' '}
              <strong style={{ fontWeight: '600' }}>{`"${searchValue.trim()}"`}</strong>
            </span>
          </div>
        )}

        {/* ── Content ── */}
        {loading ? renderLoadingState() :
         error ? renderErrorState() :
         filteredProjects?.length === 0 ? (
           projectFilter === 'mine' ? (
             <div style={{
               display: 'flex', flexDirection: 'column', alignItems: 'center',
               justifyContent: 'center', minHeight: '400px', textAlign: 'center', padding: '2rem'
             }}>
               <div style={{
                 width: '120px', height: '120px', backgroundColor: '#f1f5f9', borderRadius: '50%',
                 display: 'flex', alignItems: 'center', justifyContent: 'center',
                 marginBottom: '1.5rem', border: '3px dashed #cbd5e1'
               }}>
                 <i className="fa-solid fa-folder-open" style={{ fontSize: '48px', color: '#94a3b8' }}></i>
               </div>
               <h3 style={{ fontSize: '1.5rem', fontWeight: '600', color: '#1e293b', marginBottom: '0.5rem' }}>
                 You have no projects yet
               </h3>
               <p style={{ fontSize: '1rem', color: '#64748b', marginBottom: '2rem', maxWidth: '420px', lineHeight: '1.5' }}>
                 Create or join a project to see it here under <strong>My Projects</strong>.
               </p>
             </div>
           ) : renderEmptyState()
         ) : (
           <>
             <div
               style={{
                 display: 'grid',
                gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
                gap: '24px',
                 transition: 'opacity 0.18s ease-in-out, transform 0.18s ease-in-out',
                 opacity: isFiltering ? 0.3 : 1,
                 transform: isFiltering ? 'scale(0.99)' : 'scale(1)',
               }}
             >
               {filteredProjects?.map(project => renderCard(project))}
             </div>

             {/* ── Load More ── */}
             {hasMore && (
               <div style={{ display: 'flex', justifyContent: 'center', marginTop: '3rem', marginBottom: '2rem' }}>
                 <button
                   onClick={loadMoreProjects}
                   disabled={loadingMore}
                   style={{
                     backgroundColor: loadingMore ? '#f1f5f9' : 'white',
                     color: loadingMore ? '#94a3b8' : '#4880FF',
                     border: loadingMore ? '1px solid #e2e8f0' : '2px solid #e0e7ff',
                     padding: '10px 20px', borderRadius: '12px', fontSize: '15px', fontWeight: '600',
                     cursor: loadingMore ? 'not-allowed' : 'pointer',
                     display: 'flex', alignItems: 'center', gap: '10px',
                     boxShadow: loadingMore ? 'none' : '0 2px 8px rgba(72,128,255,0.15)',
                     opacity: loadingMore ? 0.6 : 1, transition: 'all 0.3s ease'
                   }}
                 >
                   {loadingMore ? (
                     <>
                       <div style={{
                         width: '16px', height: '16px', border: '2px solid #cbd5e1',
                         borderTop: '2px solid #94a3b8', borderRadius: '50%',
                         animation: 'spin 0.8s linear infinite'
                       }}></div>
                       Loading...
                     </>
                   ) : (
                     <>
                       <i className="fa-solid fa-arrow-down" style={{ fontSize: '14px' }}></i>
                       Load More
                     </>
                   )}
                 </button>
               </div>
             )}
           </>
         )
        }

        {/* ── Scroll to top ── */}
        {filteredProjects?.length > 4 && showScrollTop && (
          <button
            onClick={scrollToTop}
            title="Scroll to top"
            style={{
              position: 'fixed', bottom: '50px', right: '20px',
              width: '40px', height: '40px', backgroundColor: '#4880FF', color: 'white',
              border: 'none', borderRadius: '50%', cursor: 'pointer',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              boxShadow: '0 4px 12px rgba(72,128,255,0.4)', zIndex: 1000, fontSize: '18px',
              transition: 'all 0.3s ease'
            }}
          >
            <i className="fa-solid fa-arrow-up"></i>
          </button>
        )}

        {showDeletedLaunchConfirm ? (
          <div
            className="ws-launch-backdrop"
            role="presentation"
            onClick={handleCloseDeletedLaunchConfirm}
          >
            <div
              className="ws-launch-card"
              role="dialog"
              aria-modal="true"
              aria-labelledby="ws-launch-title"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="ws-launch-icon">
                <i className="fa-solid fa-rocket" />
              </div>
              <h3 id="ws-launch-title">Launch this app again?</h3>
              <p>
                The environment for this app was deleted. Opening it will start a new Sandbox session.
              </p>
              <div className="ws-launch-app">
                <div className="ws-launch-app-mark">
                  {getInitials(pendingLaunchProject?.name || 'App')}
                </div>
                <div style={{ minWidth: 0, flex: 1 }}>
                  <div className="ws-launch-app-name">
                    {pendingLaunchProject?.name || 'Untitled App'}
                  </div>
                  <div className="ws-launch-app-meta">Edited {formatDate(pendingLaunchProject?.updatedDate)}</div>
                </div>
                <span
                  className="status-pill"
                  style={{
                    background: getStatusPillStyle('DELETED').bg,
                    color: getStatusPillStyle('DELETED').color,
                  }}
                >
                  <span className="status-pill-dot" style={{ background: getStatusColor('DELETED') }} />
                  Stopped
                </span>
              </div>
              <div className="ws-launch-steps">
                <div className="ws-launch-step is-from">
                  <strong>Stopped</strong>
                  <span>Environment stopped</span>
                </div>
                <i className="fa-solid fa-arrow-right ws-launch-arrow" />
                <div className="ws-launch-step is-to">
                  <strong>Launch Sandbox</strong>
                  <span>Starts a new Sandbox session</span>
                </div>
              </div>
              <div className="ws-launch-actions">
                <button type="button" className="ws-launch-btn" onClick={handleCloseDeletedLaunchConfirm}>
                  Not now
                </button>
                <button type="button" className="ws-launch-btn primary" onClick={handleConfirmDeletedLaunch}>
                  <i className="fa-solid fa-rocket me-2" />
                  Launch Sandbox
                </button>
              </div>
            </div>
          </div>
        ) : null}

        {/* ══════════════════════════════════════════
            RENAME MODAL
        ══════════════════════════════════════════ */}
        <Modal
          show={showRenameModal}
          onHide={handleCloseRenameModal}
          centered size="md"
          backdrop keyboard
          className="rename-project-modal"
          style={{ zIndex: 10000 }}
          enforceFocus restoreFocus
        >
          <style>{`
            .rename-project-modal { z-index: 10000 !important; position: fixed !important; top:0 !important; left:0 !important; width:100% !important; height:100% !important; }
            .rename-project-modal .modal-dialog { z-index: 10001 !important; margin: 1.75rem auto; position: relative; max-width: 500px; }
            .rename-project-modal .modal-content { border-radius: 12px; border: none; box-shadow: 0 20px 60px rgba(0,0,0,0.15); overflow: hidden; position: relative; z-index: 10002 !important; }
            .rename-project-modal + .modal-backdrop { z-index: 9999 !important; }
            .rename-project-modal .modal-header { background-color:#fff; border-bottom:none; padding:1.75rem 1.75rem 0; }
            .rename-project-modal .modal-body { padding:1.5rem 1.75rem; background-color:#fff; }
            .rename-project-modal .modal-footer { background-color:#fff; border-top:1px solid #f1f5f9; padding:1.25rem 1.75rem 1.75rem; }
          `}</style>
          <ModalHeader closeButton style={{ borderBottom: 'none', paddingBottom: '0' }}>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', width: '100%' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                <div style={{ width: '40px', height: '40px', borderRadius: '10px', backgroundColor: '#e0e7ff', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <i className="fa-solid fa-pencil" style={{ color: '#4880FF', fontSize: '18px' }}></i>
                </div>
                <h4 style={{ fontSize: '20px', fontWeight: '700', color: '#1e293b', margin: 0 }}>Rename app</h4>
              </div>
              <p style={{ fontSize: '14px', color: '#64748b', margin: '0 0 0 52px' }}>Updated app name will show in your workspace</p>
            </div>
          </ModalHeader>
          <ModalBody style={{ paddingTop: '1.5rem' }}>
            <div>
              <label style={{ display: 'block', fontSize: '14px', fontWeight: '600', color: '#1e293b', marginBottom: '8px' }}>App Name</label>
              <input
                type="text"
                placeholder={renamingProject ? `e.g., ${renamingProject?.name || 'My App'}` : 'Enter app name'}
                className="form-control"
                value={renameValue}
                onChange={e => setRenameValue(e.target.value)}
                onKeyDown={e => { if (e.key === 'Enter') handleSaveRename(); else if (e.key === 'Escape') handleCloseRenameModal(); }}
                autoFocus
                style={{ width: '100%', padding: '12px 16px', fontSize: '15px', color: '#1e293b', backgroundColor: '#fff', border: '2px solid #e2e8f0', borderRadius: '10px', outline: 'none', transition: 'all 0.2s ease' }}
                onFocus={e => { e.target.style.borderColor = '#4880FF'; e.target.style.boxShadow = '0 0 0 4px rgba(72,128,255,0.1)'; }}
                onBlur={e => { e.target.style.borderColor = '#e2e8f0'; e.target.style.boxShadow = 'none'; }}
              />
              {renamingProject && (
                <div style={{ marginTop: '8px', fontSize: '12px', color: '#94a3b8', fontStyle: 'italic', display: 'flex', alignItems: 'center', gap: '6px' }}>
                  <i className="fa-solid fa-lightbulb" style={{ fontSize: '12px' }}></i>
                  <span>Current name: <strong style={{ color: '#64748b' }}>{renamingProject?.name || 'Untitled Project'}</strong></span>
                </div>
              )}
            </div>
          </ModalBody>
          <ModalFooter style={{ display: 'flex', justifyContent: 'flex-end', gap: '12px' }}>
            <Button variant="secondary" onClick={handleCloseRenameModal}
              style={{ padding: '10px 20px', fontSize: '14px', fontWeight: '500', borderRadius: '8px', border: '1px solid #e2e8f0', backgroundColor: '#fff', color: '#64748b' }}>
              Cancel
            </Button>
            <Button variant="primary" onClick={handleSaveRename} disabled={!renameValue.trim()}
              style={{ padding: '10px 20px', fontSize: '14px', fontWeight: '500', borderRadius: '8px', border: 'none', backgroundColor: !renameValue.trim() ? '#cbd5e1' : '#4880FF', color: '#fff', cursor: !renameValue.trim() ? 'not-allowed' : 'pointer' }}>
              <i className="fa-solid fa-check me-2"></i>Save Changes
            </Button>
          </ModalFooter>
        </Modal>

        {/* ══════════════════════════════════════════
            SHARE MODAL
        ══════════════════════════════════════════ */}
        <Modal
          show={showShareModal}
          onHide={handleCloseShareModal}
          centered size="lg"
          backdrop keyboard
          className="share-project-modal"
          style={{ zIndex: 10000 }}
          enforceFocus restoreFocus
        >
          <style>{`
            .share-project-modal { z-index: 10000 !important; }
            .share-project-modal .modal-dialog { z-index: 10001 !important; max-width: 560px; }
            .share-project-modal .modal-content { border-radius: 12px; border: none; box-shadow: 0 20px 60px rgba(0,0,0,0.15); overflow: visible; z-index: 10002 !important; }
            .share-project-modal .modal-header {
              background: linear-gradient(180deg, #f8fafc 0%, #ffffff 100%);
              border-bottom: 1px solid #e2e8f0 !important;
              padding: 1.25rem 1.5rem 1rem !important;
            }
            .share-project-modal .modal-body { padding: 1rem 1.5rem 1rem; background-color: #fff; max-height: 60vh; overflow-y: auto; }
            .share-project-modal .modal-footer { background-color: #fff; border-top: 1px solid #f1f5f9; padding: 1rem 1.5rem 1.25rem; overflow: visible; position: relative; z-index: 5; }
          `}</style>
          <ModalHeader closeButton>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', width: '100%', paddingRight: '8px' }}>
              <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
                <div style={{
                  width: '44px',
                  height: '44px',
                  borderRadius: '12px',
                  background: 'linear-gradient(135deg, #4880FF 0%, #6366f1 100%)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexShrink: 0,
                  boxShadow: '0 6px 16px rgba(72,128,255,0.28)',
                }}>
                  <i className="fa-solid fa-share-nodes" style={{ color: '#fff', fontSize: '18px' }}></i>
                </div>
                <div style={{ minWidth: 0, flex: 1 }}>
                  <div style={{
                    fontSize: '11px',
                    fontWeight: 700,
                    letterSpacing: '0.06em',
                    textTransform: 'uppercase',
                    color: '#64748b',
                    marginBottom: '2px',
                  }}>
                    Project access
                  </div>
                  <h4 style={{ fontSize: '18px', fontWeight: '700', color: '#0f172a', margin: 0, lineHeight: 1.3 }}>
                    Share project
                  </h4>
                  <div style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: '8px',
                    marginTop: '8px',
                    maxWidth: '100%',
                    padding: '6px 10px',
                    borderRadius: '8px',
                    background: '#fff',
                    border: '1px solid #e2e8f0',
                  }}>
                    <i className="fa-solid fa-folder" style={{ color: '#4880FF', fontSize: '12px', flexShrink: 0 }}></i>
                    <span style={{
                      fontSize: '13px',
                      fontWeight: 600,
                      color: '#1e293b',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                    }}>
                      {sharingProject ? (sharingProject?.name || 'Untitled Project') : '—'}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </ModalHeader>
          <ModalBody>
            <div style={{ marginBottom: '1rem' }}>
              <input
                type="text"
                placeholder="Search users by name or email..."
                className="form-control"
                value={shareUserSearch}
                onChange={e => { setShareUserSearch(e.target.value); setShareUsersPage(0); }}
                style={{
                  width: '100%', padding: '10px 14px 10px 36px', fontSize: '14px',
                  border: '2px solid #e2e8f0', borderRadius: '10px', outline: 'none',
                  backgroundImage: 'url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' width=\'16\' height=\'16\' fill=\'%2394a3b8\' viewBox=\'0 0 16 16\'%3E%3Cpath d=\'M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z\'/%3E%3C/svg%3E")',
                  backgroundRepeat: 'no-repeat', backgroundPosition: '12px center'
                }}
              />
            </div>

            {shareLoading ? (
              <div style={{ display: 'flex', justifyContent: 'center', padding: '2rem' }}>
                <div style={{ width: '32px', height: '32px', border: '3px solid #e2e8f0', borderTopColor: '#4880FF', borderRadius: '50%', animation: 'spin 0.8s linear infinite' }}></div>
              </div>
            ) : (
              <>
                {selectedShareCount > 0 && (
                  <div style={{
                    display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '12px',
                    marginBottom: '10px', padding: '10px 12px', borderRadius: '10px',
                    background: '#f8fafc', border: '1px solid #e2e8f0'
                  }}>
                    <span style={{ fontSize: '13px', color: '#475569', fontWeight: 600 }}>
                      {selectedShareCount} selected
                      {selectedNewShareCount > 0 ? ` · ${selectedNewShareCount} to share` : ''}
                      {selectedRevokeCount > 0 ? ` · ${selectedRevokeCount} to revoke` : ''}
                    </span>
                    <button
                      type="button"
                      onClick={() => {
                        setShareSelected({});
                        setShowRevokeConfirm(false);
                      }}
                      style={{
                        background: 'none',
                        border: 'none',
                        color: '#64748b',
                        fontSize: '12px',
                        fontWeight: 600,
                        cursor: 'pointer',
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: '6px',
                        padding: '4px 6px',
                        borderRadius: '6px',
                      }}
                    >
                      <i className="fa-solid fa-xmark" style={{ fontSize: '12px' }} aria-hidden="true"></i>
                      Clear selection
                    </button>
                  </div>
                )}

                <div style={{ border: '1px solid #e2e8f0', borderRadius: '10px', overflow: 'hidden' }}>
                  <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '14px' }}>
                    <thead>
                      <tr style={{ backgroundColor: '#f8fafc', borderBottom: '1px solid #e2e8f0' }}>
                        <th style={{ padding: '10px 12px', textAlign: 'left', fontWeight: '600', color: '#64748b', width: '40px' }}>
                          <input
                            type="checkbox"
                            checked={allPageSelected}
                            ref={(el) => {
                              if (el) el.indeterminate = !allPageSelected && somePageSelected;
                            }}
                            onChange={handleShareTogglePage}
                            title={allPageSelected ? 'Clear page selection' : 'Select all on this page'}
                            style={{ width: '18px', height: '18px', cursor: 'pointer', accentColor: '#4880FF' }}
                          />
                        </th>
                        <th style={{ padding: '10px 12px', textAlign: 'left', fontWeight: '600', color: '#64748b' }}>User</th>
                        <th style={{ padding: '10px 12px', textAlign: 'left', fontWeight: '600', color: '#64748b', minWidth: '120px' }}>Role</th>
                        <th style={{ padding: '10px 12px', textAlign: 'left', fontWeight: '600', color: '#64748b', width: '110px' }}>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {paginatedShareUsers.map(user => {
                        const userId = getShareUserKey(user);
                        const fullName = `${user?.firstName || ''} ${user?.lastName || ''}`.trim() || 'Unknown';
                        const isSelected = !!shareSelected[userId];
                        const baselineRole = resolveShareBaselineRole(shareBaseline, user);
                        const isShared = !!baselineRole;
                        return (
                          <tr key={userId} style={{ borderBottom: '1px solid #f1f5f9', background: isSelected ? 'rgba(72,128,255,0.04)' : '#fff' }}>
                            <td style={{ padding: '10px 12px', verticalAlign: 'middle' }}>
                              <input
                                type="checkbox"
                                checked={isSelected}
                                onChange={(e) => handleShareToggleUser(userId, e.target.checked, user)}
                                style={{ width: '18px', height: '18px', cursor: 'pointer', accentColor: '#4880FF' }}
                              />
                            </td>
                            <td style={{ padding: '10px 12px' }}>
                              <div style={{ fontWeight: '500', color: '#1e293b' }}>{fullName}</div>
                              <div style={{ fontSize: '12px', color: '#64748b' }}>{user?.email || '—'}</div>
                            </td>
                            <td style={{ padding: '10px 12px' }}>
                              <select
                                value={isSelected ? (shareSelected[userId] || baselineRole || '') : (baselineRole || '')}
                                onChange={(e) => handleShareRoleChange(userId, e.target.value)}
                                disabled={!isSelected}
                                style={{
                                  width: '100%', padding: '8px 10px', fontSize: '13px',
                                  border: '1px solid #e2e8f0', borderRadius: '8px',
                                  backgroundColor: isSelected ? '#fff' : '#f8fafc',
                                  color: '#1e293b',
                                  cursor: isSelected ? 'pointer' : 'not-allowed',
                                  minWidth: '100px',
                                }}
                              >
                                <option value="" disabled>Select role</option>
                                {SHARE_ROLES.map(r => <option key={r.value} value={r.value}>{r.label}</option>)}
                              </select>
                            </td>
                            <td style={{ padding: '10px 12px', verticalAlign: 'middle' }}>
                              {isShared ? (
                                <span style={{
                                  display: 'inline-flex', alignItems: 'center', gap: '6px',
                                  padding: '4px 8px', borderRadius: '999px', fontSize: '11px', fontWeight: 600,
                                  background: 'rgba(16,185,129,0.12)', color: '#047857'
                                }}>
                                  <span style={{ width: 6, height: 6, borderRadius: '50%', background: '#10b981' }} />
                                  Shared
                                </span>
                              ) : (
                                <span style={{ fontSize: '12px', color: '#94a3b8' }}>Not shared</span>
                              )}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>

                {filteredShareUsers.length === 0 && (
                  <div style={{ textAlign: 'center', padding: '1.5rem', color: '#64748b', fontSize: '14px' }}>
                    {shareUserSearch.trim() ? 'No users match your search.' : 'No users in this tenant.'}
                  </div>
                )}

                {shareUsersTotalPages > 1 && (
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: '1rem', padding: '0 2px' }}>
                    <span style={{ fontSize: '13px', color: '#64748b' }}>
                      Showing {shareUsersPage * SHARE_USERS_PAGE_SIZE + 1}–{Math.min((shareUsersPage + 1) * SHARE_USERS_PAGE_SIZE, filteredShareUsers.length)} of {filteredShareUsers.length}
                    </span>
                    <div style={{ display: 'flex', gap: '6px', alignItems: 'center' }}>
                      <Button variant="outline-secondary" size="sm" disabled={shareUsersPage === 0}
                        onClick={() => setShareUsersPage(p => Math.max(0, p - 1))}
                        style={{ padding: '6px 12px', fontSize: '13px', borderRadius: '8px', border: '1px solid #e2e8f0' }}>
                        Previous
                      </Button>
                      <span style={{ fontSize: '13px', color: '#64748b', minWidth: '80px', textAlign: 'center' }}>
                        Page {shareUsersPage + 1} of {shareUsersTotalPages}
                      </span>
                      <Button variant="outline-secondary" size="sm" disabled={shareUsersPage >= shareUsersTotalPages - 1}
                        onClick={() => setShareUsersPage(p => Math.min(shareUsersTotalPages - 1, p + 1))}
                        style={{ padding: '6px 12px', fontSize: '13px', borderRadius: '8px', border: '1px solid #e2e8f0' }}>
                        Next
                      </Button>
                    </div>
                  </div>
                )}
              </>
            )}
          </ModalBody>
          <ModalFooter style={{ display: 'flex', justifyContent: 'space-between', gap: '12px', flexWrap: 'wrap', position: 'relative' }}>
            <Button variant="secondary" onClick={handleCloseShareModal} disabled={shareSaving || shareRevoking}
              style={{ padding: '10px 20px', fontSize: '14px', fontWeight: '500', borderRadius: '8px', border: '1px solid #e2e8f0', backgroundColor: '#fff', color: '#64748b' }}>
              Close
            </Button>
            <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap', position: 'relative' }}>
              <div style={{ position: 'relative' }}>
                {showRevokeConfirm && selectedRevokeCount > 0 && (
                  <div
                    style={{
                      position: 'absolute',
                      bottom: 'calc(100% + 10px)',
                      right: 0,
                      zIndex: 30,
                      width: '300px',
                      background: '#fff',
                      border: '1px solid #fecaca',
                      borderRadius: '12px',
                      boxShadow: '0 10px 28px rgba(15,23,42,0.16)',
                      padding: '14px',
                    }}
                  >
                    <div style={{ position: 'absolute', right: '28px', bottom: '-6px', width: '12px', height: '12px', background: '#fff', borderRight: '1px solid #fecaca', borderBottom: '1px solid #fecaca', transform: 'rotate(45deg)' }} />
                    <div style={{ fontSize: '14px', fontWeight: 600, color: '#991b1b', marginBottom: '4px' }}>
                      Revoke access for {selectedRevokeCount} user{selectedRevokeCount === 1 ? '' : 's'}?
                    </div>
                    <div style={{ fontSize: '13px', color: '#7f1d1d', marginBottom: '12px', lineHeight: 1.45 }}>
                      Selected shared users will lose access to this project.
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px' }}>
                      <Button
                        variant="outline-secondary"
                        size="sm"
                        onClick={() => setShowRevokeConfirm(false)}
                        disabled={shareRevoking}
                        style={{ fontSize: '13px', padding: '8px 14px', borderRadius: '8px' }}
                      >
                        Cancel
                      </Button>
                      <Button
                        variant="danger"
                        size="sm"
                        onClick={handleRevokeSelected}
                        disabled={shareRevoking}
                        style={{ fontSize: '13px', padding: '8px 14px', borderRadius: '8px', backgroundColor: '#dc2626', borderColor: '#dc2626' }}
                      >
                        {shareRevoking ? 'Revoking…' : 'Confirm revoke'}
                      </Button>
                    </div>
                  </div>
                )}
                <Button
                  variant="outline-danger"
                  onClick={() => {
                    if (selectedRevokeCount === 0) return;
                    setShowRevokeConfirm(true);
                  }}
                  disabled={shareSaving || shareRevoking || selectedRevokeCount === 0}
                  style={{
                    padding: '10px 16px', fontSize: '14px', fontWeight: '500', borderRadius: '8px',
                    border: '1px solid #fecaca',
                    backgroundColor: selectedRevokeCount === 0 ? '#f8fafc' : '#fff',
                    color: selectedRevokeCount === 0 ? '#94a3b8' : '#dc2626',
                    cursor: selectedRevokeCount === 0 ? 'not-allowed' : 'pointer'
                  }}
                >
                  <i className="fa-solid fa-user-minus me-2"></i>
                  Revoke selected{selectedRevokeCount > 0 ? ` (${selectedRevokeCount})` : ''}
                </Button>
              </div>
              <Button
                variant="primary"
                onClick={handleSaveShare}
                disabled={shareSaving || shareRevoking || selectedNewShareCount === 0}
                style={{
                  padding: '10px 20px', fontSize: '14px', fontWeight: '500', borderRadius: '8px', border: 'none',
                  backgroundColor: (shareSaving || shareRevoking || selectedNewShareCount === 0) ? '#cbd5e1' : '#4880FF',
                  color: '#fff', cursor: (shareSaving || shareRevoking || selectedNewShareCount === 0) ? 'not-allowed' : 'pointer'
                }}
              >
                {shareSaving ? (
                  <>
                    <span className="me-2" style={{ display: 'inline-block', width: '14px', height: '14px', border: '2px solid rgba(255,255,255,0.3)', borderTopColor: '#fff', borderRadius: '50%', animation: 'spin 0.8s linear infinite', verticalAlign: 'middle' }}></span>
                    Sharing...
                  </>
                ) : (
                  <><i className="fa-solid fa-share-nodes me-2"></i>Share access{selectedNewShareCount > 0 ? ` (${selectedNewShareCount})` : ''}</>
                )}
              </Button>
            </div>
          </ModalFooter>
        </Modal>

      </div>
    </div>
  );
};

export default WorkspaceSection;